export class OkDialogModel {
    constructor(
        public title: string,
        public message: string,
    ) { }
}